<template>
  <div>
    <el-dialog
    :before-close="closeView"
     class="addTaskView"
      :visible.sync="showTaskDetail"
       :close-on-click-modal="false"
      width="30%">
      <span slot="title" class="dialog-footer">
        <span>任务详情</span>
      </span>
      <el-row class="description" v-if="!loading" :span="24">

        <el-col
          v-for="(item,index) in detailList"
          :key="index"
          :span="12">
           <el-col :span="8">{{item.label}}：</el-col><el-col :span="16">{{item.value}}</el-col>
        </el-col>

        <div v-if="false">

          <el-col :span="12">
            <el-col :span="8">任务名称:</el-col><el-col :span="16">{{taskDetail.taskName}}</el-col>
          </el-col>

          <el-col :span="4">任务描述:</el-col><el-col :span="8">{{taskDetail.taskName}}</el-col>

          <el-col :span="12">
  <el-col :span="8">产品名称:</el-col><el-col :span="16">{{taskDetail.productName}}</el-col>
          </el-col>

          <el-col :span="4">选择设备:</el-col><el-col :span="8">{{taskDetail.deviceName}}</el-col>
          <el-col :span="4">任务条件明细:</el-col><el-col :span="8">{{taskDetail.conditionDetailVoList}}</el-col>
          <template  v-if="taskDetail.groupField ===  'device_name'" >
            <el-col :span="4">统计粒度:</el-col><el-col :span="8">单个设备</el-col>
          </template>
          <template v-else>
            <el-col :span="4">统计维度:</el-col><el-col :span="8">{{taskDetail.groupField}}</el-col>
          </template>

          <el-col :span="4">计算维度:</el-col><el-col :span="8">{{taskDetail.fieId}}</el-col>
          <el-col :span="4">统计函数:</el-col><el-col :span="8">{{performTypeList[taskDetail.performType]}}</el-col>
          <el-col :span="4">定时运行开关:</el-col><el-col :span="8">{{taskDetail.taskStatus?'开启':'关闭'}}</el-col>

          <el-col :span="4">起始日期:</el-col><el-col :span="8">{{taskDetail.beginTime}}</el-col>
          <el-col :span="4">结束日期:</el-col><el-col :span="8">{{taskDetail.endTime}}</el-col>

          <el-col :span="4">调度周期:</el-col><el-col :span="8">{{peroidList[taskDetail.schedulerPeriod]}}</el-col>

          <el-col :span="4"  v-if="taskDetail.schedulerPeriod && taskDetail.schedulerPeriod.toString() === '2'" label="指定时间">
            <el-select disabled v-model="taskDetail.scheduleTime" multiple placeholder="请选择">
                <el-option
                  v-for="item in weekList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
          </el-col>
          <el-col :span="4"  v-if="taskDetail.schedulerPeriod && taskDetail.schedulerPeriod.toString() === '3'"  label="指定时间">
            <el-select disabled v-model="taskDetail.scheduleTime" multiple placeholder="请选择">
                <el-option
                  v-for="item in weekList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
          </el-col>

          <el-col :span="4"  v-if="taskDetail.schedulerPeriod && taskDetail.schedulerPeriod.toString() === '1'"  label="具体时间">
            <el-select v-model="taskDetail.scheduleTime" multiple placeholder="请选择">
                <el-option
                  v-for="item in hourList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
          </el-col>

          <el-col :span="4"  v-if="taskDetail.schedulerPeriod && taskDetail.schedulerPeriod.toString() !== '1'"  label="具体时间">
            {{taskDetail.hour+':'+taskDetail.minute}}
          </el-col>

          <template  v-if="taskDetail.schedulerPeriod" >
            <el-col :span="4" label="统计方式">{{taskDetail.schedulerPeriod.toString() === '1'?'按天统计':'按小时统计'}}</el-col>
          <el-col :span="8">{{peroidList[taskDetail.schedulerPeriod]}}</el-col>
          </template>
        </div>

      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="closeView" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { taskDetail } from '@/api/dataStatistics'
export default {
  components: {
  },
  props: {
    showTaskDetail: {
      tyhpe: Boolean
    },
    taskDetail: {
      type: Object || null
    }
  },
  data: function () {
    return {
      performTypeList: ['总数', '最大值', '最小值', '求和', '平均'],
      peroidList: {
        1: '小时',
        2: '周',
        3: '月'
      },
      weekList: [
        { label: '星期一', value: '1' },
        { label: '星期二', value: '2' },
        { label: '星期三', value: '4' },
        { label: '星期四', value: '5' },
        { label: '星期五', value: '6' },
        { label: '星期六', value: '7' },
        { label: '星期日', value: '8' },
        { label: '每个星期', value: '*' }
      ],
      loading: true,
      detaillist: []
    }
  },
  computed: {
    // 整点时间
    hourList () {
      let i = 0
      const list = []
      while (i < 24) {
        list.push(
          { label: `${i}点`, value: i }
        )
        i++
      }
      list.push(
        { label: '每个小时', value: '*' }
      )
      return list
    },
    dayList () {
      let i = 1
      const list = []
      while (i < 32) {
        list.push(
          { label: `每月${i}日`, value: i }
        )
        i++
      }
      list.push(
        { label: '每日', value: '*' }
      )
      return list
    }
  },
  created () {
    this.getTaskDetail()
  },
  methods: {
    closeView () {
      this.$emit('closeView')
    },
    getTaskDetail () {
      this.loading = true
      const params = {
        taskId: this.taskDetail.taskId
      }
      taskDetail(params).then(res => {
        res = res.data
        console.log('任务详情：', res)
        console.log('任务详情：', JSON.stringify(res))
        this.loading = false
        if (res.code === 200) {
          Object.assign(this.taskDetail, res.data)
          let type = ''
          if (this.taskDetail.type.toString() === '1') {
            type = '属性'
          } else if (this.taskDetail.type.toString() === '2') {
            type = '事件'
          } else {
            type = '服务'
          }
          this.detailList = [
            // { label: '任务编号', value: this.taskDetail.taskId },
            { label: '任务名称', value: this.taskDetail.taskName },
            { label: '任务描述', value: this.taskDetail.taskDesc },
            { label: '产品key', value: this.taskDetail.productKey },
            { label: '产品名称', value: this.taskDetail.productName },
            { label: '设备名称', value: this.taskDetail.deviceName },
            { label: '任务状态', value: this.taskDetail.taskStatus.toString() === '1' ? '关闭' : '开启' },
            { label: '选择时间方式', value: this.taskDetail.statisticsWay.toString() === '1' ? '昨天数据' : '当天数据' },
            { label: '统计方式', value: this.taskDetail.way.toString() === '1' ? '按天统计' : '按小时统计' },
            { label: '统计类型', value: type },
            { label: '调度周期', value: this.peroidList[this.taskDetail.schedulerPeriod] },
            { label: '执行类型', value: this.performTypeList[this.taskDetail.performType] },
            { label: '计算度量', value: this.taskDetail.fieId },
            { label: '统计维度', value: this.taskDetail.groupField === 'device_name' ? '单个设备' : this.taskDetail.groupField },
            { label: '条件类型', value: this.taskDetail.conditionType.toString() === '1' ? '且' : '或' },
            { label: '生效开始时间', value: this.taskDetail.beginTime },
            { label: '生效结束时间', value: this.taskDetail.endTime },
            { label: '条件明细', value: this.taskDetail.conditionDetailVoList }
          ]
          // this.taskDetail.scheduleTime = this.taskDetail.scheduleTime.split(',')
        }
      })
    }
  }
}
</script>
<style lang="less" scope>
.description{
  line-height: 30px;
  .el-col:nth-child(odd){
    text-align: right;
  }
  .el-col:nth-child(even){
    // padding-right: 10px;
    text-align: left
  }
}
</style>
